// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"89":"1bb29ac8","119":"8e9fc12e","223":"7e6aebed","635":"4d6c5b3a","674":"481ffb6f"}[chunkId] + ".js";
};